import { View, StyleSheet } from "react-native";
import { useAppConfig } from "../../../AppConfigProvider";
import { MenuCircle, ExitArrow, BookCircle, Sidebar } from "../../svgs/common";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import { MotiView, AnimatePresence } from "moti";

function MobileHeader({
  isMenuOpen,
  isShowLearn,
  isLearnOpen,
  onMenuOpenPress,
  onMenuClosePress,
  onLearnOpenPress,
  isShowCustomCoursework,
  onCustomCourseworkPress,
  isCustomCourseworkOpen,
}) {
  const appConfig = useAppConfig();

  const primaryColor = appConfig.primaryColor;

  return (
    <View style={styles.container} accessibilityRole="header">
      <View style={styles.row}>
        {isMenuOpen || isLearnOpen || isCustomCourseworkOpen ? (
          <CustomButton
            leftIcon={<ExitArrow fill={primaryColor} style={styles.menuCircle} />}
            styleType="transparent"
            style={styles.menuButton}
            onPress={onMenuClosePress}
            aria-label="Close menu"
          />
        ) : (
          <CustomButton
            leftIcon={<MenuCircle fill={primaryColor} style={styles.menuCircle} />}
            styleType="transparent"
            style={styles.menuButton}
            onPress={onMenuOpenPress}
            aria-label="Open menu"
          />
        )}
        <AnimatePresence>
          {isShowLearn && !isMenuOpen && (
            <>
              <CustomSpacing type="horizontal" size="xl" />
              <MotiView
                key="levelProgress"
                transition={{ delay: 600 }}
                from={{
                  opacity: 0,
                  scale: 0.5,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.9,
                }}>
                {!isLearnOpen && (
                  <CustomButton
                    leftIcon={<BookCircle style={styles.menuCircle} />}
                    styleType="transparent"
                    style={styles.menuButton}
                    onPress={onLearnOpenPress}
                    aria-label="Open learn menu"
                  />
                )}
              </MotiView>
            </>
          )}
          {isShowCustomCoursework && !isMenuOpen && (
            <>
              <CustomSpacing type="horizontal" size="xl" />
              <MotiView
                key="customCoursework"
                transition={{ delay: 600 }}
                from={{
                  opacity: 0,
                  scale: 0.5,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                exit={{
                  opacity: 0,
                  scale: 0.9,
                }}>
                {!isCustomCourseworkOpen && (
                  <CustomButton
                    leftIcon={<Sidebar heigh={45} width={45} />}
                    styleType="transparent"
                    style={styles.menuButton}
                    onPress={onCustomCourseworkPress}
                    aria-label="Open custom coursework menu"
                  />
                )}
              </MotiView>
            </>
          )}
        </AnimatePresence>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  menuCircle: {
    width: 45,
    height: 45,
  },
  menuButton: {
    padding: 0,
  },
});

export default MobileHeader;
